<template>
  <svg width="1em" height="1em" viewBox="0 0 24 24">
    <path
      d="M12 6.5A2.5 2.5 0 0 1 14.5 9a2.5 2.5 0 0 1-2.5 2.5A2.5 2.5 0 0 1 9.5 9A2.5 2.5 0 0 1 12 6.5M12 2a7 7 0 0 1 7 7c0 5.25-7 13-7 13S5 14.25 5 9a7 7 0 0 1 7-7m0 2a5 5 0 0 0-5 5c0 1 0 3 5 9.71C17 12 17 10 17 9a5 5 0 0 0-5-5z"
      fill="currentColor"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "MdiMapMarkerOutline",
};
</script>
